import { wpBlockVideoHandler } from "@blocks/wp-block-video/script";
import { embedCover } from "@blocks/atonal-video-embed/view";

export function initIfAtLeast(swiperEl, n = 1) {
	return swiperEl.querySelectorAll('.swiper-slide').length > n || swiperEl.setAttribute('swiper-off', 'true')
}

export function reinitVideos(swiperEl) {
	let playingVideos = swiperEl.querySelectorAll('video[data-state="playing"]')
	let duplicatedVideos = swiperEl.querySelectorAll('.swiper-slide-duplicate video');
	playingVideos && playingVideos.forEach(video => {
		wpBlockVideoHandler.videoStop(video);
	})
	setTimeout(() => {
		duplicatedVideos && wpBlockVideoHandler.videoStatesListeners(duplicatedVideos);
	}, 500);
}

export function stopIframes(swiperEl) {
	let iframe = swiperEl.querySelector('.swiper-slide-active [data-provider] iframe');
	iframe && embedCover.stopVideo(iframe)
}

export function setActiveMediaSizesVar(swiperEl, transitionTime = 0) {
	const mediaSize = () => {
		let media = swiperEl.querySelector('.swiper-slide-active');
		media = media && media.querySelector('picture,iframe,video').getBoundingClientRect();
		media && swiperEl.style.setProperty('--slide-active-media-height', `${media.height}px`)
		media && swiperEl.style.setProperty('--slide-active-media-width', `${media.width}px`)
	}
	setTimeout(mediaSize, transitionTime);
}
